import { render } from "./RecommendedAudience.vue?vue&type=template&id=1e3dc626&scoped=true"
import script from "./RecommendedAudience.vue?vue&type=script&lang=js"
export * from "./RecommendedAudience.vue?vue&type=script&lang=js"

import "./RecommendedAudience.vue?vue&type=style&index=0&id=1e3dc626&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3dc626"]])

export default __exports__